import React from 'react'
import { ColumnProps } from 'antd/lib/table'

import { Table } from 'src/components/Ant'

import { WrapTableDiv } from '../../styles'

export interface R6HeaderTableGeneric {
  name: string
  percent: string
  total: number
}

interface R6HeaderTableProps {
  columns: ColumnProps<R6HeaderTableGeneric>[]
  dataSource: R6HeaderTableGeneric[]
}

function R6HeaderTable({ columns, dataSource }: R6HeaderTableProps) {
  return (
    <WrapTableDiv>
      <Table
        className="table-sm"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </WrapTableDiv>
  )
}

export default R6HeaderTable
